// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/components/ui/dropzone/dropzone.less
// module id = 2715
// module chunks = 0 1